exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".variant-link[data-v-21f826e6]{display:flex;padding:5px 15px}.variant-link span[data-v-21f826e6]:last-child{margin-left:auto;text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/tmp/build_919341db/resources/nuxt/assets","/static":"/tmp/build_919341db/resources/nuxt/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-21f826e6","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/nuxt/pages/office/products/glass/shower/_id.vue
// module id = gVF+
// module chunks = 33